import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "onboarding-modal" }
const _hoisted_2 = { class: "progress-bar" }
const _hoisted_3 = { class: "progress-steps" }
const _hoisted_4 = { class: "step-number" }
const _hoisted_5 = { class: "progress-line" }
const _hoisted_6 = { class: "step-container" }
const _hoisted_7 = { class: "navigation" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { key: 1 }

import { ref, computed, watch } from 'vue'
import { useStore } from 'vuex'
import BaseModal from '@/components/common/BaseModal.vue'
import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
import OnboardingStep1 from './OnboardingStep1.vue'
import OnboardingStep2 from './OnboardingStep2.vue'
import OnboardingStep3 from './OnboardingStep3.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props



const store = useStore()

const step = computed(() => store.state.onboardingStep)
const loading = computed(() => store.state.isLoading)

// Step data
const step1Data = ref({
  businessUrl: '',
  aboutBusiness: '',
})

const step2Data = ref({
  fieldsOfInterest: [] as string[],
  keywordsToMonitor: [] as string[],
})

const step3Data = ref({
  name: '',
  toneOfVoice: '',
  styleGuide: '',
  speechPatternGuidelines: '',
})

// Validation
const canProceed = computed(() => {
  if (step.value === 1) {
    return step1Data.value.aboutBusiness.trim().length > 0
  }
  if (step.value === 2) {
    return step2Data.value.fieldsOfInterest.length > 0
  }
  return true
})

const canComplete = computed(() => {
  return (
    step3Data.value.name.trim().length > 0 &&
    step3Data.value.toneOfVoice.trim().length > 0 &&
    step3Data.value.styleGuide.trim().length > 0
  )
})

// Navigation
const nextStep = async () => {
  if (step.value === 2) {
    // Save steps 1 and 2 data
    await store.dispatch('completeOnboarding', {
      about_business: step1Data.value.aboutBusiness,
      business_url: step1Data.value.businessUrl || undefined,
      fields_of_interest: step2Data.value.fieldsOfInterest,
      keywords_to_monitor: step2Data.value.keywordsToMonitor,
    })
  } else {
    store.commit('SET_ONBOARDING_STEP', step.value + 1)
  }
}

const prevStep = () => {
  store.commit('SET_ONBOARDING_STEP', step.value - 1)
}

const complete = async () => {
  await store.dispatch('completeOnboardingWriter', {
    name: step3Data.value.name,
    tone_of_voice: step3Data.value.toneOfVoice,
    style_guide: step3Data.value.styleGuide,
    speech_pattern_guidelines: step3Data.value.speechPatternGuidelines || undefined,
  })
}

// Prefill data from user when modal opens (step is determined by checkOnboarding action)
watch(() => props.modelValue, (newVal) => {
  if (newVal) {
    const user = store.state.user
    if (user) {
      // Prefill step 1 data from existing user data
      step1Data.value = {
        businessUrl: '', // Not stored on user, only used for parsing
        aboutBusiness: user.about_business || '',
      }
      // Prefill step 2 data from existing user data
      step2Data.value = {
        fieldsOfInterest: user.fields_of_interest || [],
        keywordsToMonitor: user.keywords_to_monitor || [],
      }
    }
    // Note: Step is determined by checkOnboarding action based on existing user data
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "model-value": __props.modelValue,
    size: "lg",
    "show-close": false,
    "close-on-overlay": false,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (s) => {
              return _createElementVNode("div", {
                key: s,
                class: _normalizeClass(["progress-step", { active: s <= step.value, completed: s < step.value }])
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(s), 1)
              ], 2)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: "progress-fill",
              style: _normalizeStyle({ width: `${((step.value - 1) / 2) * 100}%` })
            }, null, 4)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (step.value === 1)
            ? (_openBlock(), _createBlock(OnboardingStep1, {
                key: 0,
                "initial-data": step1Data.value,
                onUpdate: _cache[0] || (_cache[0] = ($event: any) => (step1Data.value = $event))
              }, null, 8, ["initial-data"]))
            : (step.value === 2)
              ? (_openBlock(), _createBlock(OnboardingStep2, {
                  key: 1,
                  "initial-data": step2Data.value,
                  onUpdate: _cache[1] || (_cache[1] = ($event: any) => (step2Data.value = $event))
                }, null, 8, ["initial-data"]))
              : (_openBlock(), _createBlock(OnboardingStep3, {
                  key: 2,
                  "initial-data": step3Data.value,
                  onUpdate: _cache[2] || (_cache[2] = ($event: any) => (step3Data.value = $event))
                }, null, 8, ["initial-data"]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (step.value > 1)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-secondary",
                onClick: prevStep
              }, " Back "))
            : _createCommentVNode("", true),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "spacer" }, null, -1)),
          (step.value < 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-primary",
                disabled: !canProceed.value,
                onClick: nextStep
              }, " Continue ", 8, _hoisted_8))
            : (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-primary",
                disabled: !canComplete.value || loading.value,
                onClick: complete
              }, [
                (loading.value)
                  ? (_openBlock(), _createBlock(LoadingSpinner, {
                      key: 0,
                      size: "sm"
                    }))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, "Complete Setup"))
              ], 8, _hoisted_9))
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})